var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('ContentLoader',{attrs:{"isDisplay":!_vm.contentReady}}),(_vm.contentReady)?_c('section',[_c('LayoutHeader',{attrs:{"fields":_vm.fields}}),_vm._t("default"),_c('LayoutFooter')],2):_vm._e(),_c('ModalLogin'),_c('ModalRegister'),_c('ModalForgetPassword'),_c('ModalFullPicture'),_c('ModalLanguage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }